import { Card, Group, Text } from "@mantine/core"
import dayjs from "dayjs"
import { ActivityTypeText } from "../art/activities/-components/activity-type-text"
import { ProductionTitleText } from "./production-title"
import { StatusBadge } from "./status-badge"
import { getFormattedTimePeriod } from "../../../utils/get-formatted-time"
import { ActivityDto } from "@/orval/gen"

interface Props {
  item: ActivityDto
  onClickItem: (activity: ActivityDto) => void
}

export function ActivityListItemCard({ item, onClickItem }: Props) {
  return (
    <Card
      w={"100%"}
      key={item.activityId}
      style={{ cursor: "pointer" }}
      shadow="xs"
      onClick={() => onClickItem(item)}
    >
      <Group justify="space-between">
        <Group gap={"xs"}>
          <Text children={dayjs(item.date).format("dd L")} />
          <Text children={getFormattedTimePeriod(item.timePeriod)} />
        </Group>
        <StatusBadge status={item.status} />
      </Group>
      <Group justify="space-between" gap={"xs"}>
        <Group gap={"xs"}>
          <ActivityTypeText
            name={item.activityType.shortName}
            rehearseNumber={item.rehearseNumber}
            foreColor={item.activityType.foreColor}
            backColor={item.activityType.backColor}
          />
          <ProductionTitleText productionTitle={item.title} />
        </Group>
        <Text children={item.location} />
      </Group>
    </Card>
  )
}
